import { Component } from "@angular/core";
import { GoogleAnalyticsService } from "@/core/services";

@Component({ templateUrl: "pagenotfound.component.html" })
export class PageNotFoundComponent {
  constructor(private googleService: GoogleAnalyticsService) {
    this.googleService.record(
      "navigation",
      "404 page",
      "navigate to 404 page (not found)",
    );
  }
}
